import React, { useEffect } from "react";
// import { ChatContainer } from "../../src/ChatContainer";
import { ChatContainer } from "@alku/cactai-fe";
import { AuthProvider } from "./auth/hooks/useAuth";
import { MsalProvider } from "@azure/msal-react";
import { BrowserRouter } from "react-router-dom";
import msalInstance from "./auth/msal/msal-instance";
import "./standalone.css";

export function App() {
  useEffect(() => {
    (window as any).msalInstance = msalInstance;
  }, []);

  return (
    <BrowserRouter>
      <MsalProvider instance={msalInstance}>
        <AuthProvider>
          <ChatContainer standalone={process.env.STANDALONE ? true : false}/>
        </AuthProvider>
      </MsalProvider>
    </BrowserRouter>
  );
}
